import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const USD_TO_RUB = 92.0;

export function getCostRub(data) {
    if (typeof data === "object" && data) {
        if (data.cost_rub != null) return data.cost_rub;
        const usd = data.cost_usd_total ?? data.cost_usd;
        return usd ? usd * USD_TO_RUB : 0;
    }
    return data || 0;
}

export function formatCostRub(data) {
    return `${Number(getCostRub(data) || 0).toFixed(2)} ₽`;
}
